(() => {
  class VenroDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.variants = JSON.parse(this.querySelector('[data-delivery-variants]')?.textContent || '{}');
      this.root = this.closest('venro-customizer,venro-coaster-customizer,venro-wheel-customizer,venro-holiday-customizer') || this.closest('section') || document;
      this.refresh = () => {
        const id = this.root.querySelector('[name="id"]')?.value || this.dataset.variant;
        this.setOrigin(this.variants[id] || this.dataset.origin);
      };
      this.root.addEventListener('change', () => queueMicrotask(this.refresh), {signal:this.abort.signal});
      this.root.addEventListener('venro:variant-change', this.refresh, {signal:this.abort.signal});
      this.refresh();
      this.timer = setInterval(this.refresh, 60000);
    }
    disconnectedCallback() { this.abort?.abort(); clearInterval(this.timer); }
    setOrigin(origin) {
      const valid = origin === 'US' || origin === 'CN';
      this.dataset.currentOrigin = valid ? origin : '';
      this.querySelector('[data-delivery-origin]').textContent = origin === 'US' ? this.dataset.us : origin === 'CN' ? this.dataset.cn : this.dataset.unknown;
      const output = this.querySelector('[data-delivery-date]');
      const preparation = this.querySelector('[data-delivery-preparation]');
      preparation.hidden = !valid;
      preparation.textContent = origin === 'US' ? this.dataset.prepUs : origin === 'CN' ? this.dataset.prepCn : '';
      output.hidden = !valid;
      if (!valid) { output.textContent = ''; return; }
      const now = new Date();
      const day = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 12);
      const format = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {year:'numeric',month:'short',day:'numeric',timeZone:'UTC'});
      const [min,max] = origin === 'US' ? [5,10] : [10,17];
      output.textContent = this.dataset.estimate.replace('[start]',format.format(new Date(day+min*86400000))).replace('[end]',format.format(new Date(day+max*86400000)));
    }
  }
  if (!customElements.get('venro-delivery-estimate')) customElements.define('venro-delivery-estimate', VenroDeliveryEstimate);
})();
